import api from "../utils/api";

const API_URL = process.env.REACT_APP_API_URL;

export const getUsers = async () => {
  const response = await api.post(
    `${API_URL}/users.php`,
    { action: "getAll" },
    {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    }
  );
  return response.data.users || [];
};

export const getUsersByRole = async (role) => {
  const response = await api.post(
    `${API_URL}/users.php`,
    { role, action: "getByRole" },
    {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    }
  );
  return response.data.users || [];
};
